import {Component, Input, OnInit} from '@angular/core';
import {DialogService} from '../../services/dialog.service';
import {Folder} from '../../models/folder.model';
import {FolderHierarchy} from '../../models/folder.model';
import {FolderService} from '../../services/folder.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {extractErrorMessage} from '../../utils/error-utils';

@Component({
  selector: 'app-folder-picker',
  templateUrl: './folder-picker.component.html',
  styleUrls: ['./folder-picker.component.scss']
})
export class FolderPickerComponent implements OnInit {

  @Input() rootFolderId: string;
  @Input() selectedSubject: Subject<{ folder: Folder, path: string }>;
  public currentFolder: FolderHierarchy;
  public currentFolderChildren: FolderHierarchy[] = [];
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  public path: FolderHierarchy[] = [];

  private root: FolderHierarchy;
  private parentMap = new Map<string, FolderHierarchy>();

  constructor(private dialogService: DialogService,
              private folderService: FolderService) {
  }

  ngOnInit(): void {
    this.loadHierarchy();
  }

  private loadHierarchy(): void {
    this.loadingSubject.next(true);
    this.folderService.hierarchy(this.rootFolderId).pipe(
      finalize(() => this.loadingSubject.next(false))
    ).subscribe({
      next: (hierarchy) => {
        this.root = hierarchy;
        this.buildParentMap(hierarchy, null);
        this.currentFolder = hierarchy;
        this.currentFolderChildren = hierarchy.children || [];
        this.path = [hierarchy];
        this.emitSelection();
      },
      error: (error) => {
        this.dialogService.error(extractErrorMessage(error));
      }
    });
  }

  private buildParentMap(node: FolderHierarchy, parent: FolderHierarchy): void {
    if (parent) {
      this.parentMap.set(node.id, parent);
    }
    for (const child of (node.children || [])) {
      this.buildParentMap(child, node);
    }
  }

  navigate(folderId?: string): void {
    if (folderId) {
      const selected = this.currentFolderChildren.find((item) => item.id === folderId);
      this.currentFolder = selected;
      this.currentFolderChildren = selected.children || [];
      this.path.push(selected);
    } else {
      const parent = this.parentMap.get(this.currentFolder.id);
      if (parent) {
        this.currentFolder = parent;
        this.currentFolderChildren = parent.children || [];
        this.path.pop();
      }
    }
    this.emitSelection();
  }

  gotoPath(selected: FolderHierarchy): void {
    const idx = this.path.indexOf(selected);
    this.path = this.path.slice(0, idx + 1);
    this.currentFolder = selected;
    this.currentFolderChildren = selected.children || [];
    this.emitSelection();
  }

  private emitSelection(): void {
    this.selectedSubject.next({
      folder: {id: this.currentFolder.id, name: this.currentFolder.name} as Folder,
      path: this.getPath()
    });
  }

  getPath(): string {
    return this.path.map((item) => item.name).join(' > ');
  }
}
